import MagneticSwitches from "../classes/MagneticSwitch"

export const magneticSwitches = [
  new MagneticSwitches({alias:"acometida", svgSrc: "/symbol-assets/Acometida.svg", label: "Label for Type 1"}),
  new MagneticSwitches({alias:"arco", svgSrc: "/symbol-assets/Arco.svg", label: "Label for Type 2"}),
  new MagneticSwitches({alias:"condensador", svgSrc: "/symbol-assets/Condensador.svg", label: "Label for Type 3"}),
];
